import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class VisibleElementsSnappingControlsElementsConfiguration  {
    /**
     * Indicates whether to display the header.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare header?: boolean;
    /**
     * Indicates whether to display the `enabledToggle` (Enable snapping).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare enabledToggle?: boolean;
    /**
     * Indicates whether to display the `selfEnabledToggle` (Geometry guides).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare selfEnabledToggle?: boolean;
    /**
     * Indicates whether to display the `featureEnabledToggle` (Feature to feature).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare featureEnabledToggle?: boolean;
    /**
     * Indicates whether to display the [FeatureSnappingLayerSource](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-FeatureSnappingLayerSource.html) layerList.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Editor.html#VisibleElements)
     */
    @JsonProperty()
    declare layerList?: boolean;

    constructor() {}
}
